<modal>
  <span header>{{title}}</span>
  <textarea [(ngModel)]="text"></textarea>
  <div class="flex">
    <button class="text-white bg-success" (click)="save()"><i class="fa fa-save"></i><span>{{'Lưu' | lang}}</span></button>
    <button class="text-white bg-warning" (click)="close()"><i class="fa fa-arrow-left"></i><span>{{'Đóng' | lang}}</span></button>
  </div>
</modal>
